import React, { useEffect } from 'react'
import { Box, Button, Pagination, Stack, TableBody, TableCell, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import { formatUserType, isEmpty, isNotEmpty } from '../../../utils/format';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import route from '../../../utils/Routes';
import BackButton from '../../../components/BackButton';
import BgBoxOld from '../../../components/BgBoxOld';
import { getDeptEmpListServ, rmvEmpFromDept } from '../../../services/dept-service';
import StyledTableContainer from '../../../components/StyledTableContainer';
import AssignDeptUser from './AssignDeptUser';
import { useState } from 'react';


function DeptEmpListPage({ type = 'amtc' }) {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { setLoadingScreen, setNavComValue, ctxtUser } = useAuthContext();
    const limit = 7;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const deptId = parseInt(searchParams.get("deptId") || "1");
    const queryClient = useQueryClient()
    const { isLoading, isError, error, data: empData } = useQuery([QueryKey.deptEmpList, pgNo, deptId],
        () => getDeptEmpListServ({ deptId, limit, pgNo }), {
        enabled: isNotEmpty(deptId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });
    const [assMdl, setAssMdl] = useState(false);
    const handleAssMdlClose = () => setAssMdl(false);
    const handleAssMdlOpen = () => setAssMdl(true);


    const columns = [
        {
            id: 'empName',
            label: "Employee Name",
            align: 'left',
            minWidth: 150,
        },
        {
            id: 'empId',
            label: "Employee ID",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'username',
            label: "Email ID",
            align: 'left',
            minWidth: 150,
        },
        {
            id: 'role',
            label: "Employee Role",
            align: 'left',
            minWidth: 150
        },
        ...(type === 'com' ? [{
            id: 'btn',
            label: "",
            align: 'left',
            minWidth: 50
        }] : [])
    ];

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (empData?.deptInfo?.comId)
            setNavComValue({ comId: empData?.deptInfo?.comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, empData]);

    const handleRowClick = (userId) => {
        if (type === "amtc")
            navigate(`${route.aComUserProfile}/?userId=${userId}`);
        else
            navigate(`${route.cUserProfile}/?userId=${userId}`);
    };

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };


    async function handleRmvClick(i) {
        setLoadingScreen(true);
        try {
            const payload = {
                userId: i?.userId,
                deptId
            }
            const { message } = await rmvEmpFromDept(payload);
            notify("success", message);
            queryClient.invalidateQueries();
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"}>
            <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
                <BackButton width={"20%"} />
                <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                    <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Departments - {empData?.deptInfo?.deptName}</Typography>
                </Stack>
                <Stack width={"20%"} alignItems={"end"}>
                    {empData?.deptInfo?.isApproved === 1 ? (type === "com" && <Button variant='outlined' onClick={handleAssMdlOpen} sx={{
                        fontSize: 13, ml: 5,
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Assign Employee</Button>) : <Stack sx={{
                            bgcolor: empData?.deptInfo?.isApproved === 1 ? "rgba(0, 120, 10,0.4)" : "orange", fontSize: 12,
                            fontWeight: 500, px: 2, py: 0.7, borderRadius: 16, width: 160, alignItems: "center"
                        }}>
                        {formatUserType(empData?.deptInfo?.isApproved)}
                    </Stack>}
                </Stack>
            </Stack>

            <BgBoxOld height={"93%"} py={1}>
                {empData && <StyledTableContainer height={"90%"} isStickyHeader={true}>
                    <TableHead>
                        <TableRow >
                            {columns.map((column) => (
                                <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(empData?.empArr || []).map((i) => {
                            return (
                                <React.Fragment key={i?.id}>
                                    <TableRow hover tabIndex={-1}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50 }} >
                                        {columns.map((column) => {
                                            const value = i[column.id];
                                            switch (column.id) {
                                                case "empName":
                                                    return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {isEmpty(i?.userId) ? "NA" : <Button variant="text" sx={{ color: "black", ml: -1, fontSize: 12 }} onClick={() => handleRowClick(i?.userId)}>
                                                            {value}
                                                        </Button>}
                                                    </TableCell>
                                                case "role":
                                                    return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {formatUserType(i?.userType)}
                                                    </TableCell>
                                                case "btn":
                                                    return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        <Button variant='outlined' onClick={() => handleRmvClick(i)} sx={{
                                                            fontSize: 13, width: 100, height: 27,
                                                            color: "red", borderColor: "red"
                                                        }}>
                                                            REMOVE</Button>
                                                    </TableCell>
                                                default:
                                                    return (
                                                        <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                            {(value === null || value === "" || value === "null") ? "NA" : value}
                                                        </TableCell>
                                                    );
                                            }
                                        })}
                                    </TableRow>
                                </React.Fragment>
                            );
                        })}
                    </TableBody>
                </StyledTableContainer>}
                <Stack sx={{ alignItems: "center", mt: 2 }}>
                    <Pagination count={Math.ceil(empData?.totalEmpCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
                        variant="outlined" shape="rounded" />
                </Stack>
            </BgBoxOld>
            {empData && <AssignDeptUser modalOpen={assMdl} handleModalClose={handleAssMdlClose} comId={ctxtUser?.comId} deptData={empData?.deptInfo} />}
        </Box>
    )
}
export default DeptEmpListPage;